const ENTITY_ID_PATTERN = /^[a-zA-Z0-9_-]+$/;

export function isValidEntityId(id: unknown): id is string {
  if (typeof id !== 'string') return false;
  const value = id.trim();
  if (!value || value === 'null' || value === 'undefined') return false;
  return ENTITY_ID_PATTERN.test(value);
}

export function uniqueValidEntityIds(ids: unknown[]): string[] {
  return Array.from(new Set(ids.filter(isValidEntityId).map((id) => id.trim())));
}
